import Discovery from '@/models/Discovery'
import Api from '@/services/api'
import { each, find } from 'lodash'

export default {
  namespaced: true,
  state: {
    list: [],
    listMeta: {
      current_page: 0,
      last_page: 1,
    },
    discoveryDetails: null,
  },

  mutations: {
    setDiscoveryList(state, discoveries) {
      each(discoveries, (discovery) => {
        const exist = find(state.list, { id: discovery.id })
        if (!exist) {
          state.list.push(new Discovery(discovery))
        }
      })
    },

    clearDiscoveryList(state) {
      state.list = []
    },

    setDiscoveryListMeta(state, meta) {
      state.listMeta = meta
    },

    setDiscoveryDetails(state, discovery) {
      if (discovery instanceof Discovery) {
        state.discoveryDetails = discovery
      } else {
        state.discoveryDetails = new Discovery(discovery)
      }
    },

    clearDiscoveryDetails(state) {
      state.discoveryDetails = null
    },
  },

  actions: {
    async getDiscoveries({ commit }, params) {
      const query = Discovery.page(params.page || 1).orderBy(params.sort)

      if (params.search) {
        query.where('search', params.search)
      }

      const res = await query.params({ limit: 20 }).get()
      commit('setDiscoveryList', res.data)
      commit('setDiscoveryListMeta', res.meta)
    },

    async getDiscoveryDetails({ commit }, id) {
      const { data } = await Api.get(`admin/discoveries/${id}`)
      commit('setDiscoveryDetails', data.data)
    },

    async createDiscovery({ commit }, formData) {
      const { data } = await Api.post(`admin/discoveries`, formData)
      commit('setDiscoveryDetails', data.data)
    },

    async updateDiscovery({ commit }, formData) {
      const { data } = await Api.post(
        `admin/discoveries/${formData.get('id')}?_method=PUT`,
        formData
      )
      commit('setDiscoveryDetails', data.data)
    },

    async deleteDiscovery({ commit }, id) {
      await Api.delete(`admin/discoveries/${id}`)
      commit('clearDiscoveryDetails', id)
    },

    async exportToExcel({ commit }, params) {
      let endpoint = params.search
        ? `admin/discoveries/export/${params.search}`
        : `admin/discoveries/export`
      const file = await Api.get(endpoint, {
        responseType: 'blob',
      })
      return file
    },
  },
}
